require('echarts');
require('@chartisan/echarts');
